import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "isHpa",
    initialState: false,
    reducers: {
        set: (state, action) => action.payload,
    },
});
